import {
  Button,
  Heading,
  Square,
  Squish,
  Stack,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import React, { ReactNode } from 'react';
import { Modal } from 'src/components/Modal/Modal';

export interface AddNewPeopleSuccessModalContainerProps {
  onClose: () => void;
  employeeCount: number;
  children: ReactNode;
}

export function AddNewPeopleSuccessModalContainer({
  onClose,
  employeeCount,
  children,
}: AddNewPeopleSuccessModalContainerProps): JSX.Element {
  const successMessage = `${employeeCount} ${
    employeeCount === 1 ? 'new person added!' : 'new people added!'
  }`;

  return (
    <Modal size="sm">
      <Square as="header" width="100%">
        <Button
          variant="tertiary"
          type="button"
          className="closeModalButton"
          onClick={onClose}
        >
          <SvgX aria-label="close" size="24px" />
        </Button>
        <Squish inset="md">
          <Stack y="xxx-sm">
            <Heading variant="h2">{successMessage}</Heading>
          </Stack>
          Here’s what to expect next:
        </Squish>
      </Square>
      {children}
    </Modal>
  );
}
